import { render, staticRenderFns } from "./new_trusteeship.vue?vue&type=template&id=4e1c6e7e&scoped=true&"
import script from "./new_trusteeship.vue?vue&type=script&lang=js&"
export * from "./new_trusteeship.vue?vue&type=script&lang=js&"
import style0 from "./new_trusteeship.vue?vue&type=style&index=0&id=4e1c6e7e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1c6e7e",
  null
  
)

export default component.exports